import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client for the app.
 *
 * - gcTime 5m: keep inactive query data cached for five minutes before GC.
 * - retry 1: one retry on failure (auth/router error handling lands in later tickets).
 * - refetchOnWindowFocus false: avoid surprise refetches when tabbing back in.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
